module.exports = {"520304001":"南白街道","520304002":"播南街道","520304003":"影山湖街道","520304004":"桂花桥街道","520304005":"龙坑街道","520304102":"三岔镇","520304103":"苟江镇","520304104":"三合镇","520304105":"乌江镇","520304106":"龙坪镇","520304107":"团溪镇","520304108":"铁厂镇","520304109":"西坪镇","520304110":"尚嵇镇","520304111":"茅栗镇","520304112":"新民镇","520304113":"鸭溪镇","520304114":"石板镇","520304115":"乐山镇","520304116":"枫香镇","520304117":"泮水镇","520304118":"马蹄镇","520304200":"平正仡佬族乡","520304201":"洪关苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520304.json
// module id = 2464
// module chunks = 0